import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface ApiResponse<T = any> {
  results: T[];
  count: number;
  next?: string | null;
}

export const fetchAllBaoCaoSoDuTaiKhoan = async (
  entitySlug: string,
  body: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.post<ApiResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.BAO_CAO_SO_DU_TAI_KHOAN}/`,
      body,
      {
        params: {
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (pageResults.length < pageSize) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
